import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";
import dayjs from "dayjs";

const CoordinatorService = {
    // Existing login function

    addCoordinator: async (name, email, mobile, dateOfBirth, qualification, addressLineOne, addressLineTwo, state, district, taluka, pinCode, termsChecked) => {
        try {
            const response = await axios.post(
                ApiConstants.addCoordinator,
                {
                    name: name,
                    email: email,
                    mobile: mobile,
                    dateOfBirth: dateOfBirth,
                    qualification: qualification,
                    addressLineOne: addressLineOne,
                    addressLineTwo: addressLineTwo,
                    state: state,
                    district: district,
                    taluka: taluka,
                    pinCode: pinCode,
                    notifyEmail: termsChecked
                },
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },


    getAllCoordinator: async (offset, limit, searchQuery) => {
        try {
            const response = await axios.get(
                ApiConstants.getAllCoordinator +
                `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`,
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    updateCommission: async (id, commissionPer) => {
        try {
            const response = await axios.post(ApiConstants.updateCommission, {
                coordinatorId: id,
                commissionPer: commissionPer
            }
                ,
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },


    updateCoordinatorStatus: async (id, status) => {
        try {
            const response = await axios.post(
                ApiConstants.updateCoordinatorStatus,
                {
                    coordinatorId: id,
                    isActive: status,
                },
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    getAllCoordinatorDetail: async (id) => {
        try {
            const response = await axios.get(ApiConstants.getAllCoordinatorDetail + id, {
                headers: {
                    Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error
        }
    },

    getAllPurchaseList: async (coordinatorid, offset, limit, startDate, endDate) => {
        try {
            // Construct the query string with the provided dates
            const queryParams = new URLSearchParams({
                coordinatorId: coordinatorid,
                offset: offset,
                limit: limit,
            });

            // Append startDate and endDate if they are provided
            if (startDate) {
                queryParams.append('startDate', dayjs(startDate).format('YYYY-MM-DD'));
            } else {
                queryParams.append('startDate', "");
            }
            if (endDate) {
                queryParams.append('endDate', dayjs(endDate).format('YYYY-MM-DD'));
            } else if (startDate && !endDate) {
                queryParams.append('endDate', dayjs(new Date()).format('YYYY-MM-DD'));
            } else {
                queryParams.append('endDate', "");
            }

            // Construct the full URL
            const url = `${ApiConstants.getAllPurchaseList}?${queryParams.toString()}`;
            const response = await axios.get(url,
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    getAllCoordinatorWithdrawlRequest: async (offset, limit, coordinatorId) => {
        try {
            const response = await axios.get(
                ApiConstants.getAllCoordinatorWithdrawlRequest +
                `?coordinatorId=${coordinatorId}&offset=${offset}&limit=${limit}`,
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    getAllCoordinatorRequest: async (coordinatorId) => {
        try {
            const response = await axios.get(ApiConstants.getAllCoordinatorRequest +
                `?coordinatorId=${coordinatorId}`, {
                headers: {
                    Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error
        }
    },

    editCoordinator: async (id, name, email, mobile, dateOfBirth, qualification, addressLineOne, addressLineTwo, state, district, taluka, pinCode, termsChecked) => {
        try {
            const response = await axios.post(
                ApiConstants.editCoordinator,
                {
                    coordinatorId: id,
                    name: name,
                    email: email,
                    mobile: mobile,
                    dateOfBirth: dateOfBirth,
                    qualification: qualification,
                    addressLineOne: addressLineOne,
                    addressLineTwo: addressLineTwo,
                    state: state,
                    district: district,
                    taluka: taluka,
                    pinCode: pinCode,
                    notifyEmail: termsChecked
                },
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    withdrwalRequest: async (id, paidAmount, modeOfPayment, transactionId) => {
        try {
            const response = await axios.post(
                ApiConstants.withdrwalRequest,
                {
                    requestId: id,
                    paidAmount: paidAmount,
                    modeOfPayment: modeOfPayment,
                    transactionId: transactionId,
                },
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    transactionHistory: async (id, offset, limit, startDate, endDate) => {
        try {
            // Construct the query string with the provided dates
            const queryParams = new URLSearchParams({
                coordinatorId: id,
                offset: offset,
                limit: limit,
            });

            // Append startDate and endDate if they are provided
            if (startDate) {
                queryParams.append('startDate', dayjs(startDate).format('YYYY-MM-DD'));
            } else {
                queryParams.append('startDate', "");
            }
            if (endDate) {
                queryParams.append('endDate', dayjs(endDate).format('YYYY-MM-DD'));
            } else if (startDate && !endDate) {
                queryParams.append('endDate', dayjs(new Date()).format('YYYY-MM-DD'));
            } else {
                queryParams.append('endDate', "");
            }

            // Construct the full URL
            const url = `${ApiConstants.transactionHistory}?${queryParams.toString()}`;

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                },
            });

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

};

export default CoordinatorService;
